var _circle, _circle2, _circle3, _rect, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 10,
    viewBox: "0 0 123 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#FF0000",
    fillOpacity: 0.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 5,
    r: 5,
    fill: "#FF0000",
    fillOpacity: 0.59
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 5,
    r: 5,
    fill: "#FF0000",
    fillOpacity: 0.59
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 27,
    height: 10,
    rx: 5,
    fill: "#FF0000",
    fillOpacity: 0.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 5,
    r: 5,
    fill: "#FF0000",
    fillOpacity: 0.59
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 5,
    r: 5,
    fill: "#FF0000",
    fillOpacity: 0.59
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 5,
    r: 5,
    fill: "#FF0000",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.8c0ae725604ee2842eabfbda0dba3769.svg";
export { ForwardRef as ReactComponent };